import { ReactNode } from 'react';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
  variant?: 'default' | 'auth';
  onContactSupport?: () => void;
}

export default function Layout({ children, variant = 'default', onContactSupport }: LayoutProps) {
  return (
    <div className="relative flex min-h-screen flex-col">
      <div className="flex h-full grow flex-col">
        <Header variant={variant} onContactSupport={onContactSupport} />
        {children}
      </div>
    </div>
  );
}
